module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/chart-pie-a727452aa14e9636f214b9227666eaca.svg";